import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const RecipeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recipe, setRecipe] = useState(null);

  useEffect(() => {
    const load = async () => {
      const ref = doc(db, "admin", "recipes", "items", id);
      const snap = await getDoc(ref);
      if (snap.exists()) setRecipe({ id: snap.id, ...snap.data() });
    };
    load();
  }, [id]);

  return (
    <div className="flex items-center justify-center min-h-[80vh] px-2 py-8 ">
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg border border-gray-200 p-0 overflow-hidden">
        <div className="relative">
          {recipe && <img src={recipe.image} alt={recipe.name} className="w-full h-64 object-cover" />}
          <button onClick={() => navigate(-1)} className="absolute top-4 left-4 bg-white/80 hover:bg-white text-[#d90429] rounded-full p-2 shadow transition flex items-center justify-center">
            <FaArrowLeft className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 sm:p-8 flex flex-col gap-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 leading-tight">{recipe?.name || "Loading..."}</h2>
          <div className="flex flex-wrap gap-2 mb-2">
            {recipe && <span className="inline-block px-4 py-1 rounded-full text-sm font-semibold bg-orange-100 text-orange-700">{recipe.category}</span>}
            {recipe && <span className="inline-block px-4 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-600">{recipe.language || "English"}</span>}
          </div>

          <div className="mt-4 prose max-w-none text-gray-700 entry-content" dangerouslySetInnerHTML={{ __html: recipe?.htmlContent || "" }} />
        </div>
      </div>
    </div>
  );
};

export default RecipeDetail;
